export default "__VITE_ASSET__d148cad9__"